import { jsx } from "react/jsx-runtime";
import { memo, Suspense } from "react";
import { useSelector } from "react-redux";
import { lazyImport } from "@nxplatform/helpers/helpers";
import { selectIFinanceCheckEnabled } from "@nxplatform/platform-settings/platform-settings.selectors";
const { PlayLimitCheckPrivate } = lazyImport(
  () => import("./play-limit-check.private.js"),
  "PlayLimitCheckPrivate"
);
const PlayLimitCheckWrapper = () => {
  const iFinanceCheckEnabled = useSelector(selectIFinanceCheckEnabled);
  if (!iFinanceCheckEnabled) return null;
  return /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(PlayLimitCheckPrivate, {}) });
};
const _PlayLimitCheckWrapper = memo(PlayLimitCheckWrapper);
export {
  _PlayLimitCheckWrapper as PlayLimitCheckWrapper
};
